import React from "react";
import Moment from "react-moment";
import { Link } from "react-router-dom";
import { FormattedMessage } from "react-intl";
import { Table, TableContainer, TableHead, TableBody, TableCell, TableRow, Typography } from "@material-ui/core";

import Number from "../../../../custom/Number";
import LeadershipCommissionList from "../LeadershipCommissionList";
import UserCommissionValue from "../UserCommissionValue";
import { compareByPhaseAndInitialDateAndId } from "../../../../util";

const getCellColor = (c) => (c.status !== "ARCHIVE" ? "#EEE" : "#999");

const ContractsTable = ({ contracts = [] }) => {
  if (!contracts.length) return null;

  return (
    <div
      style={{
        paddingLeft: 10,
        paddingTop: 0,
        paddingBottom: 16,
        paddingRight: 10,
        color: "#999",
      }}
    >
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell style={{ color: "#999" }}>Id</TableCell>
              <TableCell
                align="right"
                style={{ color: "#999" }}
              >
                <small>
                  <FormattedMessage id="app.value" />
                </small>
              </TableCell>
              <TableCell
                align="center"
                style={{ color: "#999" }}
              >
                <small>
                  <FormattedMessage id="app.date.start" />
                </small>
              </TableCell>
              <TableCell
                align="center"
                style={{ color: "#999" }}
              >
                <small>
                  <FormattedMessage id="app.date.final" />
                </small>
              </TableCell>
              <TableCell
                align="center"
                style={{ color: "#999" }}
              >
                <small>
                  <FormattedMessage id="app.report.status" />
                </small>
              </TableCell>
              <TableCell
                align="right"
                style={{ color: "#999" }}
              >
                <small>
                  <FormattedMessage id="app.addition" />
                </small>
              </TableCell>
              <TableCell
                align="right"
                style={{ color: "#999", textAlign: "center" }}
              >
                <small>
                  <FormattedMessage id="app.commission.type.BONUS" />
                </small>
              </TableCell>
              <TableCell
                align="right"
                style={{ color: "#999" }}
              >
                <small>
                  <FormattedMessage id="app.commission.type.BONUS_MANAGER" />
                </small>
              </TableCell>
              <TableCell
                align="right"
                style={{ color: "#999" }}
              >
                <small>
                  <FormattedMessage id="app.commission.type.BONUS_LEADERSHIP_ONE_TIME" />
                </small>
              </TableCell>
              <TableCell
                align="center"
                style={{ color: "#999", textAlign: "center" }}
              >
                <small>
                  <FormattedMessage id="app.commission.type.BONUS_MANAGER_SPLIT" />
                </small>
              </TableCell>
              <TableCell
                align="right"
                style={{ color: "#999" }}
              >
                <small>
                  <FormattedMessage id="app.commission.type.BONUS_SPLIT" />
                </small>
              </TableCell>
              <TableCell
                align="right"
                style={{ color: "#999" }}
              >
                <small>
                  <FormattedMessage id="app.commission.type.BONUS_RECOMMENDANT" />
                </small>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {contracts.sort(compareByPhaseAndInitialDateAndId).map((c) => {
              const cellColor = getCellColor(c);

              return (
                <TableRow key={c.id}>
                  <TableCell>
                    <Typography
                      component={Link}
                      style={{
                        textDecoration: "none",
                        color: cellColor,
                      }}
                      to={`/userContract/${c.id}`}
                      variant="body2"
                    >
                      {`C ${c.id}`}
                    </Typography>
                  </TableCell>
                  <TableCell
                    align="right"
                    style={{
                      color: cellColor,
                    }}
                  >
                    <Number value={c.amount} />
                  </TableCell>
                  <TableCell
                    align="center"
                    style={{
                      color: cellColor,
                    }}
                  >
                    <Moment
                      format="DD/MM/YYYY"
                      date={c.initialDate}
                    />
                  </TableCell>
                  <TableCell
                    align="center"
                    style={{
                      color: cellColor,
                    }}
                  >
                    <Moment
                      format="DD/MM/YYYY"
                      date={c.dueDate}
                    />
                  </TableCell>
                  <TableCell
                    align="center"
                    style={{
                      color: cellColor,
                    }}
                  >
                    <FormattedMessage id={`app.enuns.${c.phase}`} />
                  </TableCell>
                  {c.status !== "ARCHIVE" ? (
                    <>
                      <TableCell
                        align="right"
                        style={{
                          color: cellColor,
                        }}
                      >
                        <UserCommissionValue
                          userId={c.customerId}
                          amount={c.yield}
                        />
                      </TableCell>
                      <TableCell
                        align="right"
                        style={{
                          color: cellColor,
                        }}
                      >
                        <UserCommissionValue
                          userId={c.agentId}
                          amount={c.commission}
                        />
                      </TableCell>
                      <TableCell
                        align="right"
                        style={{
                          color: cellColor,
                        }}
                      >
                        {c.managerId ? (
                          <UserCommissionValue
                            userId={c.managerId}
                            amount={c.managerValue}
                          />
                        ) : (
                          "N/A"
                        )}
                      </TableCell>{" "}
                      <TableCell
                        align="right"
                        style={{
                          color: cellColor,
                        }}
                      >
                        <LeadershipCommissionList leaderships={c.leaderships} />
                      </TableCell>
                      <TableCell
                        align="right"
                        style={{
                          color: cellColor,
                        }}
                      >
                        {c.managerId && !!c.managerSplit ? (
                          <UserCommissionValue
                            userId={c.managerId}
                            amount={c.managerSplit}
                          />
                        ) : (
                          "N/A"
                        )}
                      </TableCell>
                      <TableCell
                        align="right"
                        style={{
                          color: cellColor,
                        }}
                      >
                        {c.splitAgentId ? (
                          <UserCommissionValue
                            userId={c.splitAgentId}
                            amount={c.split}
                          />
                        ) : (
                          "N/A"
                        )}
                      </TableCell>
                      <TableCell
                        align="right"
                        style={{
                          color: cellColor,
                        }}
                      >
                        {c.recommenderId ? (
                          <UserCommissionValue
                            userId={c.recommenderId}
                            amount={c.recommenderValue}
                          />
                        ) : (
                          "N/A"
                        )}
                      </TableCell>
                    </>
                  ) : (
                    <>
                      <TableCell
                        align="center"
                        colSpan={4}
                        style={{
                          color: cellColor,
                        }}
                      ></TableCell>
                    </>
                  )}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default ContractsTable;
